module.exports = __webpack_public_path__ + "img/Frame 5124.4c4be9f5.jpg";